import React, { useEffect } from "react";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="w-full text-black mt-10 mx-auto flex max-w-[900px] self-center flex-col min-h-[100vh] items-center px-20 p-4 max-sm:px-4 gap-5">
      <h3 className="text-2xl font-bold">TERMS AND CONDITIONS</h3>

      <span className="text-left leading-6	tracking-wide	">
      Welcome to the EasyDiagnostic App, a powerful tool designed to help
        dealerships track and manage their sales teams efficiently. These terms
        and conditions govern your use of the App, so please read them
        carefully.
      </span>

      <h3 className="text-xl font-semibold">ACCEPTANCE OF TERMS</h3>

      <span className="text-left leading-6	tracking-wide	">
        By using the App, you agree to be bound by these terms and conditions.
        If you do not agree to these terms, do not use the app.
      </span>

      <h3 className="text-xl font-semibold">USE OF APP</h3>

      <span className="text-left leading-6	tracking-wide	">
        You must be at least 18 years of age to use the App. Tirth App is
        intended for personal, non-commercial use only. You may not use the App
        for any illegal or unauthorized purpose, and you agree to comply with
        all applicable laws and regulations.
      </span>
      <span>
        Any illegal activities seen by any individual trust temple dharamshala
        bhojansala will draw legal actions.
      </span>

      <h3 className="text-xl font-semibold">REGISTRATION AND USER ACCOUNTS</h3>

      <span className="text-left leading-6	tracking-wide	">
        In order to use the App, you must register for an account. You are
        responsible for maintaining the confidentiality of your account
        information and password, and you are fully responsible for all
        activities that occur under your account.
      </span>

      <h3 className="text-xl font-semibold">
        USER CONTENT "Easy Diagnostic - MOBILE APP"
      </h3>

      <span className="text-left leading-6	tracking-wide	">
        Welcome to the Easy Diagnostic App, a community-based platform designed
        to connect users with shared interests, hobbies, and activities. Please
        read these terms and conditions carefully, as they govern your use of
        the App. ACCEPTANCE OF TERMS By using the Easy Diagnostic App, you agree
        to comply with these terms and conditions. If you do not agree, please
        do not use the App. USE OF THE APP • You must be at least 18 years old
        to use the Easy Diagnostic App. • The App is intended for personal,
        non-commercial use only. • You may not use the App for any illegal or
        unauthorized purposes. • You agree to adhere to all applicable laws and
        regulations while using the App. • Easy Diagnostic App imposes
        limitations on banner creation, event creation, and module usage. These
        limitations include count limits on a daily, weekly, monthly, or
        periodic basis. Data may automatically be removed, restricted, or
        disappear based on these time limits.
      </span>

      <h3 className="text-xl font-semibold">RESPONSIBILITY</h3>

      <span className="text-left leading-6	tracking-wide	">
        The respective Trust or Community is fully responsible for any actions
        that violate or disrespect the feelings, culture, or dignity of
        community members. The Easy Diagnostic App provides an excellent
        platform for connecting with community members. It should be used solely
        for positive and constructive purposes. The respective Trust is
        responsible for defining the rules and regulations for their members'
        participation in activities. Each user or member must be aware of and
        agree to the respective Trust's terms and conditions before using the
        App. While using this app, whether by Trusts, Trust members, or
        community members, Easy Diagnostic App is not responsible for any
        transactions, payment activities, failures, losses, or claims. Easy
        Diagnostic App does not interfere in these matters and will not
        entertain any related issues. We provide a platform to facilitate
        connections between Trusts, communities, and their users or members.
        Easy Diagnostic App is not responsible for any transactions or
        activities between Trusts and members or users.
      </span>

      <h3 className="text-xl font-semibold">REGISTRATION AND USER ACCOUNTS</h3>

      <span className="text-left leading-6	tracking-wide	">
        To use the Easy Diagnostic App, you must register for an account. You
        are responsible for maintaining the confidentiality of your account
        information and password. You are fully accountable for all activities
        that occur under your account.
      </span>

      <h3 className="text-xl font-semibold">USER CONTENT</h3>

      <span className="text-left leading-6	tracking-wide	">
        Easy Diagnostic App allows users to post content such as text, photos,
        and videos. By posting content on the App, you grant Easy Diagnostic App
        a non-exclusive, transferable, sub-licensable, royalty-free, worldwide
        license to use, reproduce, modify, adapt, publish, translate, create
        derivative works from, distribute, perform, and display your content in
        any media. You agree not to post content that is illegal, defamatory, or
        infringes on the rights of any third party. You also agree not to use
        the Easy Diagnostic App to harass, stalk, or intimidate other users.
      </span>

      <h3 className="text-xl font-semibold">PROHIBITED CONDUCT</h3>

      <span className="text-left leading-6	tracking-wide	">
        You agree not to engage in any conduct that is disruptive or harmful to
        other users, including but not limited to:
      </span>
      <ol>
        <li className="text-left leading-6	tracking-wide	">
          - Posting spam or unauthorized commercial communications
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Uploading viruses or malicious code
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Attempting to access other users' accounts
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Harassing or intimidating other users
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Impersonating another person or entity
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Violating any applicable law or regulation
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Easy Diagnostic App Developing Company will be only acting as a
          aggregators and will not be responsible for the failure of any trust,
          individuals, Temples, Dharamshalas, Bhojanshalas in discharging their
          said responsiblities.
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Easy Diagnostic App does not deal in any cash or account payee
          transactions and will not be responsible for any between two parties
          on this app.
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - UPI Payments received or paid will be between two parties and Jain
          Tirth App does not take any responsiblity for same.
        </li>

        <li className="text-left leading-6	tracking-wide	">
          - Any Banners, events, activities created posted should not be against
          any individual, panth or jain samaj. if anything so came to knowledge
          shall be deleted immediately without prior notice to anyone
        </li>
      </ol>
      <h3 className="text-xl font-semibold">INTELLECTUAL PROPERTY RIGHTS</h3>

      <span className="text-left leading-6	tracking-wide	">
        All intellectual property rights in the Easy Diagnostic App are owned by
        Jain Tirth App or its licensors. You agree not to reproduce, modify,
        distribute, or otherwise use any part of the App without the express
        written consent of Easy Diagnostic App. Violating these terms may result
        in strict penalties and legal action as per applicable laws.
      </span>

      <h3 className="text-xl font-semibold">
        DISCLAIMERS AND LIMITATIONS OF LIABILITY
      </h3>

      <span className="text-left leading-6	tracking-wide	">
        {" "}
        Easy Diagnostic App is provided "as is" without warranties of any kind,
        either express or implied. Easy Diagnostic App does not warrant that the
        App will be error-free or uninterrupted, and shall not be liable for any
        damages arising from the use of the App.
      </span>

      <h3 className="text-xl font-semibold">TERMINATION</h3>

      <span className="text-left leading-6	tracking-wide	">
        Easy Diagnostic App may terminate your account at any time if you
        violate these terms and conditions or for any other reason. Upon
        termination, your right to use the App will immediately cease.
      </span>

      <h3 className="text-xl font-semibold">GOVERNING LAW</h3>

      <span className="text-left leading-6	tracking-wide	">
        These terms and conditions are governed by and construed in accordance
        with the laws of Hubli, City Jurisdiction.
      </span>

      <h3 className="text-xl font-semibold">CHANGES TO TERMS AND CONDITIONS</h3>

      <span className="text-left leading-6	tracking-wide	">
        Easy Diagnostic App may update these terms and conditions from time to
        time. If we make material changes, we will notify you by email or by
        posting a notice in the App. By continuing to use the App, you agree to
        be bound by the most recent version of these terms and conditions.
      </span>

      <span className="text-left leading-6	tracking-wide	">
        By using the App, you agree to be bound by the most recent version of
        these terms and conditions.
      </span>
      <h3 className="underline text-xl font-semibold">Contact Us</h3>
      <span className="text-left leading-6	tracking-wide	">
        If you have any questions about this Privacy Policy, you can contact us
        at:
        <br />
        By writing on our support Email:{" "}
        <a
          className="underline font-medium"
          href="mailto:reachus@wbtechindia.com"
        >
          reachus@wbtechindia.com
        </a>
        .
        <br />
        By visiting our website:{" "}
        <a className="underline font-medium" href="http://www.wbtechindia.com">
          www.wbtechindia.com
        </a>
        ,
        <br />
        Address: CTS 122/141A, W B PLAZA, NEW COTTON MARKET, OPP TRAFFIC POLICE
        <br />
        STATION, HUBLI, Dharwad, Karnataka, 580029
      </span>
    </div>
  );
};

export default TermsAndConditions;
